// @flow


import React, {Component} from 'react';
import noop from 'lodash.noop';
import isNil from 'lodash.isnil';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './table.component.module.styl';
import {TextAlign, VerticalAlign, TEXT_ALIGN_CLASSES, VERTICAL_ALIGN_CLASSES} from './constants';


const classNames = withCssModule(styles);

/**
 * Cell component Props
 */
type CellProps = {|
    /**
     * Subtitle cell
     */
    caption?: React$Node,
    /**
     * Block type has no padding in table cell
     */
    block?: boolean,
    /**
     * Column for numbers
     */
    number?: boolean,
    /**
     * Height of table cell
     */
    height?: string | number,
    /**
     * Width of table cell
     */
    width: string | number,
    /**
     * Show/hide cell border
     */
    border: boolean,
    /**
     * White space should be normal
     */
    whiteSpaceNormal?: boolean,
    /**
     * Title on hover
     */
    title?: boolean | string,
    /**
     * Text align in table cell
     */
    align: $Values<typeof TextAlign>,
    /**
     * ID of html element
     */
    id?: string,
    /**
     * Mix for Cell
     */
    mix: string,
    /**
     * Number of colSpan
     */
    colSpan?: number,
    /**
     * Number of rowSpan
     */
    rowSpan?: number,
    /**
     * Set default Cell padding
     */
    defaultCellPadding?: boolean,
    /**
     * Set true to display white-space like nowrap
     */
    nowrap?: boolean,
    /**
     * Cell vertical align
     */
    verticalAlign?: $Values<typeof VerticalAlign>,
    /**
     * @private
     * If cell in table head
     */
    th?: boolean,
    children?: React$Node,
    onClick: () => void,

    /**
     * If cell will have thick right border
     * */
    separated?: boolean,
|};


type CellState = {|
    title: string | React$Element<any> | null,
|};


const getStyles = ({height, width, border}: { height?: string | number, width: string | number, border: boolean }) => {
    let style = {};
    style = height ? {...style, height} : style;
    style = width ? {...style, width} : style;
    style = !border ? {...style, border: 'none'} : style;
    return style;
};
export class Cell extends Component<CellProps, CellState> {
    cell: ?HTMLElement;

    state = {
        title: null
    };

    static defaultProps = {
        align: TextAlign.LEFT,
        width: '',
        border: true,
        mix: '',
        onClick: noop
    };


    onHover = () => {
        const {title} = this.props;

        if (title) {
            this.setState(state => {
                let newTitle;
                if (typeof title === 'string') {
                    if (state.title === title) {
                        return null;
                    }
                    newTitle = title;
                } else {
                    const titleFromDOM = this.cell ? this.cell.textContent : '';
                    if (state.title === titleFromDOM || !titleFromDOM) {
                        return null;
                    }
                    newTitle = titleFromDOM;
                }

                return {title: newTitle};
            });
        }
    };

    render() {
        const {title} = this.state;
        const props = this.props;
        const {colSpan, rowSpan, mix} = props;

        const className = classNames('table__col', mix,
            {
                'table__col_caption': props.caption || props.caption === '',
                'table__col_block': props.block,
                'table__col_number': props.number,
                'table__col_nowrap': props.nowrap || props.height,
                'table__col_white-space-normal': props.whiteSpaceNormal,
                'table__col_default-padding': props.defaultCellPadding,
                'table__col_separated': props.separated,
            },
            TEXT_ALIGN_CLASSES[props.align],
            VERTICAL_ALIGN_CLASSES('table__col')[props.verticalAlign || VerticalAlign.DEFAULT]);

        let content;

        if (props.caption) {
            content = <span>{props.caption}</span>;
        } else {
            content = props.caption === '' || isNil(props.children) ? <span>&nbsp;</span> : props.children;
        }

        if (this.props.title) {
            content = <span title={title} className="ellipsis">{content}</span>;
        }

        const idObj = props.id ? {id: props.id} : {};
        const cellProps = {
            colSpan,
            rowSpan,
            className,
            onClick: props.onClick,
            style: getStyles(props),
            onMouseEnter: this.props.title !== undefined ? this.onHover : noop,
            ...idObj,
            ref: el => this.cell = el
        };
        const Tag = props.th ? 'th' : 'td';

        return (
            <Tag {...cellProps}>{content}</Tag>
        );
    }
}


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
